import { REFRESH_DATA } from "../../constants/app"

const initialState = {
  corporateAction: false,
  ipoAction: false,
  orderTable: false,
  marketAction: false,
  accountAction: false
}

export const refreshReducers = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_DATA.CORPORATE_ACTION:
      return Object.assign({}, state, {
        corporateAction: action.value
      })
    case REFRESH_DATA.IPO_ACTION:
      return Object.assign({}, state, {
        ipoAction: action.value
      })
    case REFRESH_DATA.ORDER_TABLE:
      return Object.assign({}, state, {
        orderTable: action.value
      })
    case REFRESH_DATA.MARKET_ACTION:
      return Object.assign({}, state, {
        marketAction: action.value
      })
      case REFRESH_DATA.ACCOUNT_ACTION:
        return Object.assign({}, state, {
          accountAction: action.value
        })
    default:
      return state
  }
}